import _ from 'lodash';
import { createSelector } from 'reselect';
import { DEFAULT_PAGINATION, PAGINATION_MAPPINGS } from '../constants/table.constants';

const resourceSelector = (state, props = {}) => ({
  resource: props?.resource,
  state: _.get(state.resources, `${props?.resource?.key}`)
});

export const tableDataSelector = createSelector(resourceSelector, ({ state, resource }) => ({
  data: state?.data || [],
  config: state?.table || { ...DEFAULT_PAGINATION, sort: resource?.table?.defaultSort }
}));
export const tableConfigSelector = createSelector(
  resourceSelector,
  ({ state, resource }) => state?.table || { ...DEFAULT_PAGINATION, sort: resource?.table?.defaultSort }
);
export const tableMetaSelector = createSelector(resourceSelector, ({ state }) => state?.meta ?? {});
export const tableQueryParamsSelector = createSelector(tableDataSelector, ({ config }) => _.omit(config, 'total'));
export const tableSortSelector = createSelector(tableDataSelector, ({ config }) => config.sort);
export const tableSelectedSelector = createSelector(resourceSelector, ({ state }) => state?.selected ?? []);

export function resourceWithDataResetToTableState(resource, state) {
  const sort = tableSortSelector(state, { resource });
  const { config } = tableDataSelector(state, { resource });
  const meta = tableMetaSelector(state, { resource });
  const table = { sort };

  const searchParams = resource?.table?.searchParams || [];
  _.forEach(searchParams, (param) => {
    table[param] = _.get(config, param);
  });

  return { data: [], table, meta };
}

export function resourceToTableState(resp, resource, state) {
  const sort = tableSortSelector(state, { resource });
  const { config } = tableDataSelector(state, { resource });
  const pageMapping = resource?.table?.pageMapping ?? PAGINATION_MAPPINGS.DEFAULT;
  const table = { sort };
  _.forEach(pageMapping, (v, k) => {
    table[k] = _.get(resp, v);
  });
  const searchParams = resource?.table?.searchParams || [];
  _.forEach(searchParams, (param) => {
    table[param] = _.get(config, param);
  });
  const meta = resource?.table?.metaLocation ? _.get(resp, resource?.table?.metaLocation, {}) : {};
  const data = resource?.table?.dataLocation ? _.get(resp, resource?.table?.dataLocation, []) : resp || [];
  const filteredData = resource?.table?.dataFilter ? data?.filter(resource?.table?.dataFilter) : data;
  const transformedData = resource?.table?.dataTransform ? resource?.table?.dataTransform(filteredData) : filteredData;

  return { data: transformedData, table, meta };
}

export const resourceStateSelector = createSelector(resourceSelector, (res) => res.state);
